// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { Api } from "../../api";
import { News } from "../../common/interfaces/News";
import { ContentArea } from "../content_area/ContentArea";

@Component({
  mixins: [template],
  components: {
    ContentArea,
  },
})
export class HeadlineNews extends Vue {
  @Prop()
  public portalId!: number;

  private news: News[] = [];

  private visibleNews: News[] = [];

  @Watch("portalId")
  private onPortalIdChange() {
    this.loadHeadlineNews();
  }

  private created() {
    this.loadHeadlineNews();
  }

  private async loadHeadlineNews() {
    if (this.portalId) {
      this.news = await Api.pageService.getHeadlineNews(this.portalId);
      this.getVisibleNews();
    }
  }

  private getLink(newsEntry) {
    let news = newsEntry["news"];
    if (
      news["content"].hasOwnProperty("alternativeLink") &&
      news["content"]["alternativeLink"] &&
      news["content"]["alternativeLink"]["href"]
    ) {
      return news["content"]["alternativeLink"]["href"];
    }

    return null;
  }

  private getLinkTarget(newsEntry) {
    let news = newsEntry["news"];
    if (
      news["content"].hasOwnProperty("alternativeLink_target") &&
      news["content"]["alternativeLink_target"]
    ) {
      return news["content"]["alternativeLink_target"];
    }

    return "_self";
  }

  private getVisibleNews() {
    this.visibleNews = this.news.filter((entry) => {
      return this.getCookie("hide_headline_news_" + entry.id) != "1";
    });
  }

  private handleClose(event) {
    this.visibleNews.forEach((entry) => {
      let exdays: number | null = 1000;
      if (entry.portal.basic.title == "Rechtliche Hinweise und Datenschutz") {
        exdays = null;
      }
      this.setCookie("hide_headline_news_" + entry.id, "1", exdays);
    });

    this.getVisibleNews();
  }

  private setCookie(cname, cvalue, exdays) {
    if (exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        cname + "=" + cvalue + ";" + expires + ";path=/; SameSite=None; Secure";
    } else {
      document.cookie = cname + "=" + cvalue + ";path=/; SameSite=None; Secure";
    }
  }

  private getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
